'use strict';

var ChartPriceRecommendationServicesLegendDirective = function ChartPriceRecommendationServicesLegendDirective() {
  return {
    restrict: 'E',
    template: require('../templates/chart-price-recommendation-services-legend.html'),
    scope: {},
    replace: true,
    controller: 'ChartPriceRecommendationServicesLegendController'
  };
};
ChartPriceRecommendationServicesLegendDirective.$inject = [];
module.exports = ChartPriceRecommendationServicesLegendDirective;